import CaseTypeSelectMultiple from "@/components/Forms/CaseTypeSelectMultiple.tsx";
import EmployeeNameByTypeMultiple from "@/components/Forms/EmployeeNameByTypeMultiple.tsx";
import MultiSelect from "@/components/Forms/MultiSelect.tsx";
import { stateAbbreviations } from "@/constants/stateAbbreviations.ts";
import type { CaseFilterEditing } from "@/queries/useFetchCaseFiltersets.ts";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { RhfTextField } from "mui-rhf-integration";
import type React from "react";
import { useFormContext } from "react-hook-form";

const FilterGrid = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
}));

const FilterFields: React.FC = () => {
    const { control } = useFormContext<CaseFilterEditing>();

    const stateOptions = stateAbbreviations.map((state) => ({
        value: state,
        label: state,
    }));

    return (
        <FilterGrid>
            <RhfTextField name="caseNumber" control={control} label="Case #" fullWidth />
            <RhfTextField name="clientName" control={control} label="Client Name" fullWidth />
            <CaseTypeSelectMultiple name="caseType" label="Case Type" />
            <MultiSelect name="incidentState" label="Incident State" options={stateOptions} />
            <EmployeeNameByTypeMultiple label={"Created By"} name={"createdBy"} type={"All"} />
        </FilterGrid>
    );
};

export default FilterFields;
